import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconStravaStyle0 = cosmosIconCss;

const CosmosIconStrava$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconStrava extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'ead23d876775ab041fe4f415dec79d08b128641d', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'fdea2f514f8e6388cde40df3df119b8d35325b99', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '6b53e7b150ebb65786e049064fffd6858a3d1354', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "m12.449 12.445-2.243-4.427-2.238 4.428H4.672l5.534-10.934 5.541 10.933h-3.298Zm-.002 0 1.652 3.255 1.647-3.254h2.426l-4.073 8.042-4.075-8.042h2.423Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconStravaStyle0; }
}, [1, "cosmos-icon-strava", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-strava"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-strava":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconStrava$1);
            }
            break;
    } });
}

const CosmosIconStrava = CosmosIconStrava$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconStrava, defineCustomElement };
